var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box tabela"},[_c('table',{staticClass:"table",attrs:{"data-uuid":_vm.uuid}},[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column.head))])}))])])}
var staticRenderFns = []

export { render, staticRenderFns }